import React, { Component } from 'react';

import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faTiktok,
  faTwitter,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import {
  faEnvelope,
  faMapMarkerAlt,
  faPhoneAlt
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { connect } from 'react-redux';
import iosIcon from '../../assets/images/appstore.png';
import googlePlayIcon from '../../assets/images/googleplay.png';
import restaurantSettingBg from '../../assets/static/restaurent-setting-bg.svg';
import ImageHelper from '../../helpers/ImageHelper';

class Footer extends Component {

  render() {
    const {
      location,
      locationSettings
    } = this.props;
    let urlScheme = locationSettings.footer_url_scheme ? JSON.parse(locationSettings.footer_url_scheme) : [];
    const isValidHttpUrl = (string) => {
      let url;

      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }

      return url.protocol === "http:" || url.protocol === "https:";
    }
    return (
      <footer className="page-footer font-small blue pt-4 footer-bg" style={{ position: 'relative', zIndex: '1' }}>
        {locationSettings.footer_design_enable === 1 ?
          <LazyLoadImage
            className='footer-img'
            src={locationSettings.footer_img ? ImageHelper.getImageURL(`${locationSettings.footer_img}`, '?func=crop&w=1200&h=300') : restaurantSettingBg}
            alt='infobg'
          />
          : ''
        }
        <div className="container-fluid text-md-left">
          <div className="row">
            {urlScheme.length === 0 && (
              <>
                <div className="col-md-8 mt-md-0 mt-3 mb-4 footer-padding-left footer-z-index" >
                  <h3 className='footer-text-color fw-bold'>
                    {locationSettings.footer_logo ?
                      <LazyLoadImage
                        width={250}
                        height={100}
                        src={ImageHelper.getImageURL(`${locationSettings.footer_logo}`, '?func=crop&w=250&h=100')}
                        alt='infobg'
                      /> :
                      location.name}</h3>
                  <p className='footer-text-color'>{locationSettings.footer_description}</p>
                  <ul className="list-unstyled">
                    <li><a>
                      <FontAwesomeIcon icon={faMapMarkerAlt} color='var(--footer-text-color)' style={{ width: '15px' }} />
                      <span className="ps-2 footer-text-color">{location.formattedAddress}</span>
                    </a></li>
                    <li className='mt-2'><a>
                      <FontAwesomeIcon icon={faPhoneAlt} color='var(--footer-text-color)' style={{ width: '15px' }} />
                      <span className="ps-2 footer-text-color">{location.location_telephone}</span>
                    </a></li>
                    {location.whatsapp_number && (
                      <li className='mt-2'><a>
                        <FontAwesomeIcon icon={faWhatsapp} color='var(--footer-text-color)' style={{ width: '15px' }} />
                        <span className="ps-2 footer-text-color">{location.whatsapp_number}</span>
                      </a></li>
                    )}
                    {locationSettings.footer_email && (
                      <li className='mt-2'><a>
                        <FontAwesomeIcon icon={faEnvelope} color='var(--footer-text-color)' style={{ width: '15px' }} />
                        <span className="ps-2 footer-text-color">{locationSettings.footer_email}</span>
                      </a></li>
                    )}
                  </ul>
                </div>
                <div className="col-md-4 mb-md-0 mb-3 footer-z-index">
                  <ul className="list-unstyled">
                    <li className='mt-2'>
                      {locationSettings.fb_link && (<a className='' href={locationSettings.fb_link} target='_blank'><FontAwesomeIcon icon={faFacebook} color='var(--footer-text-color)' size={'2x'} /></a>)}
                      {locationSettings.insta_link && (<a className='ps-3' href={locationSettings.insta_link} target='_blank'><FontAwesomeIcon icon={faInstagram} color='var(--footer-text-color)' size={'2x'} /></a>)}
                      {locationSettings.x_link && (<a className='ps-3' href={locationSettings.x_link} target='_blank'><FontAwesomeIcon icon={faTwitter} color='var(--footer-text-color)' size={'2x'} /></a>)}
                      {locationSettings.linkedin_link && (<a className='ps-3' href={locationSettings.linkedin_link} target='_blank'><FontAwesomeIcon icon={faLinkedin} color='var(--footer-text-color)' size={'2x'} /></a>)}
                      {locationSettings.tiktok_link && (<a className='ps-3' href={locationSettings.tiktok_link} target='_blank'><FontAwesomeIcon icon={faTiktok} color='var(--footer-text-color)' size={'2x'} /></a>)}
                      {locationSettings.whatsapp_link && (<a className='ps-3' href={`https://wa.me/${locationSettings.whatsapp_link}/?text=`} target='_blank'><FontAwesomeIcon icon={faWhatsapp} color='var(--footer-text-color)' size={'2x'} /></a>)}
                    </li>
                    <li className='mt-2'>
                      {locationSettings.google_play_link && (<a className='' href={locationSettings.google_play_link} target='_blank'><img src={googlePlayIcon} className='w-25'></img></a>)}
                      {locationSettings.ios_link && (<a className='' href={locationSettings.ios_link} target='_blank'><img src={iosIcon} className='w-25'></img></a>)}
                    </li>
                  </ul>
                </div>
              </>
            )}

            {urlScheme.length === 1 && (
              <>
                <div className="col-md-8 mt-md-0 mt-3 mb-4 footer-padding-left footer-z-index" >
                  <h3 className='footer-text-color fw-bold'>
                    {locationSettings.footer_logo ?
                      <LazyLoadImage
                        width={250}
                        height={100}
                        src={ImageHelper.getImageURL(`${locationSettings.footer_logo}`, '?func=crop&w=250&h=100')}
                        alt='infobg'
                      /> :
                      location.name}</h3>
                  <p className='footer-text-color'>{locationSettings.footer_description}</p>
                  <ul className="list-unstyled">
                    <li><a>
                      <FontAwesomeIcon icon={faMapMarkerAlt} color='var(--footer-text-color)' style={{ width: '15px' }} />
                      <span className="ps-2 footer-text-color">{location.formattedAddress}</span>
                    </a></li>
                    <li className='mt-2'><a>
                      <FontAwesomeIcon icon={faPhoneAlt} color='var(--footer-text-color)' style={{ width: '15px' }} />
                      <span className="ps-2 footer-text-color">{location.location_telephone}</span>
                    </a></li>
                    {location.whatsapp_number && (
                      <li className='mt-2'><a>
                        <FontAwesomeIcon icon={faWhatsapp} color='var(--footer-text-color)' style={{ width: '15px' }} />
                        <span className="ps-2 footer-text-color">{location.whatsapp_number}</span>
                      </a></li>
                    )}
                    {locationSettings.footer_email && (
                      <li className='mt-2'><a>
                        <FontAwesomeIcon icon={faEnvelope} color='var(--footer-text-color)' style={{ width: '15px' }} />
                        <span className="ps-2 footer-text-color">{locationSettings.footer_email}</span>
                      </a></li>
                    )}
                  </ul>
                </div>

                {/* <hr className="clearfix w-100 d-md-none pb-0" /> */}
                {urlScheme && urlScheme.map((row, i) => {
                  return (
                    <div className="col-md-4 mb-md-0 mb-3 footer-z-index">
                      <h5 className="footer-text-color fw-bold">{row.name}</h5>
                      <ul className="list-unstyled">
                        {row.data && row.data.map((x) => {
                          return (
                            isValidHttpUrl(x.url) ?
                              <li className='mt-2'><a className='footer-text-color' href={isValidHttpUrl(x.url) ? x.url : ''} target={x.is_open_blank ? `_blank` : ``}>{x.name}</a></li>
                              :
                              <li className='mt-2'><a className='footer-text-color' >{x.name}</a></li>
                          )
                        }
                        )}
                        {urlScheme.length - 1 === i && (
                          <>
                            <li className='mt-2'>
                              {locationSettings.fb_link && (<a className='' href={locationSettings.fb_link} target='_blank'><FontAwesomeIcon icon={faFacebook} color='var(--footer-text-color)' size={'2x'} /></a>)}
                              {locationSettings.insta_link && (<a className='ps-3' href={locationSettings.insta_link} target='_blank'><FontAwesomeIcon icon={faInstagram} color='var(--footer-text-color)' size={'2x'} /></a>)}
                              {locationSettings.x_link && (<a className='ps-3' href={locationSettings.x_link} target='_blank'><FontAwesomeIcon icon={faTwitter} color='var(--footer-text-color)' size={'2x'} /></a>)}
                              {locationSettings.linkedin_link && (<a className='ps-3' href={locationSettings.linkedin_link} target='_blank'><FontAwesomeIcon icon={faLinkedin} color='var(--footer-text-color)' size={'2x'} /></a>)}
                              {locationSettings.tiktok_link && (<a className='ps-3' href={locationSettings.tiktok_link} target='_blank'><FontAwesomeIcon icon={faTiktok} color='var(--footer-text-color)' size={'2x'} /></a>)}
                              {locationSettings.whatsapp_link && (<a className='ps-3' href={`https://wa.me/${locationSettings.whatsapp_link}/?text=`} target='_blank'><FontAwesomeIcon icon={faWhatsapp} color='var(--footer-text-color)' size={'2x'} /></a>)}
                            </li>
                            <li className='mt-2'>
                              {locationSettings.google_play_link && (<a className='' href={locationSettings.google_play_link} target='_blank'><img src={googlePlayIcon} className='w-25'></img></a>)}
                              {locationSettings.ios_link && (<a className='' href={locationSettings.ios_link} target='_blank'><img src={iosIcon} className='w-25'></img></a>)}
                            </li>
                          </>
                        )}

                      </ul>
                    </div>
                  )
                })}

              </>
            )}

            {urlScheme.length === 2 && (
              <>
                <div className="col-md-6 mt-md-0 mt-3 mb-4 footer-padding-left footer-z-index" >
                  <h3 className='footer-text-color fw-bold'>
                    {locationSettings.footer_logo ?
                      <LazyLoadImage
                        width={250}
                        height={100}
                        src={ImageHelper.getImageURL(`${locationSettings.footer_logo}`, '?func=crop&w=250&h=100')}
                        alt='infobg'
                      /> :
                      location.name}</h3>
                  <p className='footer-text-color'>{locationSettings.footer_description}</p>
                  <ul className="list-unstyled">
                    <li><a>
                      <FontAwesomeIcon icon={faMapMarkerAlt} color='var(--footer-text-color)' style={{ width: '15px' }} />
                      <span className="ps-2 footer-text-color">{location.formattedAddress}</span>
                    </a></li>
                    <li className='mt-2'><a>
                      <FontAwesomeIcon icon={faPhoneAlt} color='var(--footer-text-color)' style={{ width: '15px' }} />
                      <span className="ps-2 footer-text-color">{location.location_telephone}</span>
                    </a></li>
                    {location.whatsapp_number && (
                      <li className='mt-2'><a>
                        <FontAwesomeIcon icon={faWhatsapp} color='var(--footer-text-color)' style={{ width: '15px' }} />
                        <span className="ps-2 footer-text-color">{location.whatsapp_number}</span>
                      </a></li>
                    )}
                    {locationSettings.footer_email && (
                      <li className='mt-2'><a>
                        <FontAwesomeIcon icon={faEnvelope} color='var(--footer-text-color)' style={{ width: '15px' }} />
                        <span className="ps-2 footer-text-color">{locationSettings.footer_email}</span>
                      </a></li>
                    )}
                  </ul>
                </div>

                {/* <hr className="clearfix w-100 d-md-none pb-0" /> */}
                {urlScheme && urlScheme.map((row, i) => {
                  return (
                    <div className="col-md-3 mb-md-0 mb-3 footer-z-index">
                      <h5 className="footer-text-color fw-bold">{row.name}</h5>
                      <ul className="list-unstyled">
                        {row.data && row.data.map((x) => {
                          return (
                            isValidHttpUrl(x.url) ?
                              <li className='mt-2'><a className='footer-text-color' href={isValidHttpUrl(x.url) ? x.url : ''} target={x.is_open_blank ? `_blank` : ``}>{x.name}</a></li>
                              :
                              <li className='mt-2'><a className='footer-text-color' >{x.name}</a></li>
                          )
                        }
                        )}
                        {urlScheme.length - 1 === i && (
                          <>
                            <li className='mt-2'>
                              {locationSettings.fb_link && (<a className='' href={locationSettings.fb_link} target='_blank'><FontAwesomeIcon icon={faFacebook} color='var(--footer-text-color)' size={'2x'} /></a>)}
                              {locationSettings.insta_link && (<a className='ps-3' href={locationSettings.insta_link} target='_blank'><FontAwesomeIcon icon={faInstagram} color='var(--footer-text-color)' size={'2x'} /></a>)}
                              {locationSettings.x_link && (<a className='ps-3' href={locationSettings.x_link} target='_blank'><FontAwesomeIcon icon={faTwitter} color='var(--footer-text-color)' size={'2x'} /></a>)}
                              {locationSettings.linkedin_link && (<a className='ps-3' href={locationSettings.linkedin_link} target='_blank'><FontAwesomeIcon icon={faLinkedin} color='var(--footer-text-color)' size={'2x'} /></a>)}
                              {locationSettings.tiktok_link && (<a className='ps-3' href={locationSettings.tiktok_link} target='_blank'><FontAwesomeIcon icon={faTiktok} color='var(--footer-text-color)' size={'2x'} /></a>)}
                              {locationSettings.whatsapp_link && (<a className='ps-3' href={`https://wa.me/${locationSettings.whatsapp_link}/?text=`} target='_blank'><FontAwesomeIcon icon={faWhatsapp} color='var(--footer-text-color)' size={'2x'} /></a>)}
                            </li>
                            <li className='mt-2'>
                              {locationSettings.google_play_link && (<a className='' href={locationSettings.google_play_link} target='_blank'><img src={googlePlayIcon} className='w-25'></img></a>)}
                              {locationSettings.ios_link && (<a className='' href={locationSettings.ios_link} target='_blank'><img src={iosIcon} className='w-25'></img></a>)}
                            </li>
                          </>
                        )}

                      </ul>
                    </div>
                  )
                })}

              </>
            )}

            {urlScheme.length === 3 && (
              <>
                <div className="col-md-3 mt-md-0 mt-3 mb-4 footer-padding-left footer-z-index" >
                  <h3 className='footer-text-color fw-bold'>
                    {locationSettings.footer_logo ?
                      <LazyLoadImage
                        width={250}
                        height={100}
                        src={ImageHelper.getImageURL(`${locationSettings.footer_logo}`, '?func=crop&w=250&h=100')}
                        alt='infobg'
                      /> :
                      location.name}</h3>
                  <p className='footer-text-color'>{locationSettings.footer_description}</p>
                  <ul className="list-unstyled">
                    <li><a>
                      <FontAwesomeIcon icon={faMapMarkerAlt} color='var(--footer-text-color)' style={{ width: '15px' }} />
                      <span className="ps-2 footer-text-color">{location.formattedAddress}</span>
                    </a></li>
                    <li className='mt-2'><a>
                      <FontAwesomeIcon icon={faPhoneAlt} color='var(--footer-text-color)' style={{ width: '15px' }} />
                      <span className="ps-2 footer-text-color">{location.location_telephone}</span>
                    </a></li>
                    {location.whatsapp_number && (
                      <li className='mt-2'><a>
                        <FontAwesomeIcon icon={faWhatsapp} color='var(--footer-text-color)' style={{ width: '15px' }} />
                        <span className="ps-2 footer-text-color">{location.whatsapp_number}</span>
                      </a></li>
                    )}
                    {locationSettings.footer_email && (
                      <li className='mt-2'><a>
                        <FontAwesomeIcon icon={faEnvelope} color='var(--footer-text-color)' style={{ width: '15px' }} />
                        <span className="ps-2 footer-text-color">{locationSettings.footer_email}</span>
                      </a></li>
                    )}
                  </ul>
                </div>

                {/* <hr className="clearfix w-100 d-md-none pb-0" /> */}
                {urlScheme && urlScheme.map((row, i) => {
                  return (
                    <div className="col-md-3 mb-md-0 mb-3 footer-z-index">
                      <h5 className="footer-text-color fw-bold">{row.name}</h5>
                      <ul className="list-unstyled">
                        {row.data && row.data.map((x) => {
                          return (
                            isValidHttpUrl(x.url) ?
                              <li className='mt-2'><a className='footer-text-color' href={isValidHttpUrl(x.url) ? x.url : ''} target={x.is_open_blank ? `_blank` : ``}>{x.name}</a></li>
                              :
                              <li className='mt-2'><a className='footer-text-color' >{x.name}</a></li>
                          )
                        }
                        )}
                        {urlScheme.length - 1 === i && (
                          <>
                            <li className='mt-2'>
                              {locationSettings.fb_link && (<a className='' href={locationSettings.fb_link} target='_blank'><FontAwesomeIcon icon={faFacebook} color='var(--footer-text-color)' size={'2x'} /></a>)}
                              {locationSettings.insta_link && (<a className='ps-3' href={locationSettings.insta_link} target='_blank'><FontAwesomeIcon icon={faInstagram} color='var(--footer-text-color)' size={'2x'} /></a>)}
                              {locationSettings.x_link && (<a className='ps-3' href={locationSettings.x_link} target='_blank'><FontAwesomeIcon icon={faTwitter} color='var(--footer-text-color)' size={'2x'} /></a>)}
                              {locationSettings.linkedin_link && (<a className='ps-3' href={locationSettings.linkedin_link} target='_blank'><FontAwesomeIcon icon={faLinkedin} color='var(--footer-text-color)' size={'2x'} /></a>)}
                              {locationSettings.tiktok_link && (<a className='ps-3' href={locationSettings.tiktok_link} target='_blank'><FontAwesomeIcon icon={faTiktok} color='var(--footer-text-color)' size={'2x'} /></a>)}
                              {locationSettings.whatsapp_link && (<a className='ps-3' href={`https://wa.me/${locationSettings.whatsapp_link}/?text=`} target='_blank'><FontAwesomeIcon icon={faWhatsapp} color='var(--footer-text-color)' size={'2x'} /></a>)}
                            </li>
                            <li className='mt-2'>
                              {locationSettings.google_play_link && (<a className='' href={locationSettings.google_play_link} target='_blank'><img src={googlePlayIcon} className='w-25'></img></a>)}
                              {locationSettings.ios_link && (<a className='' href={locationSettings.ios_link} target='_blank'><img src={iosIcon} className='w-25'></img></a>)}
                            </li>
                          </>
                        )}

                      </ul>
                    </div>
                  )
                })}

              </>
            )}

          </div>
        </div>
        <div className="margin-div-bg d-flex justify-content-center footer-bg" >
          <p class="mb-0 mt-4 primary-font-color"><a target="_blank" href="https://plugd.tech" class="ps-1 primary-font-color"><img class='pb-1' src={this.props.logo} width='20' height='23' ></img></a>&nbsp;&nbsp;<b>Powered by <a target="_blank" href="https://plugd.tech" class="ps-1 primary-font-color">Plugd</a></b></p>
        </div>
      </footer>
    );
  }

}


function mapStateToProps(state) {
  const { location, locationSettings } = state;
  return { location, locationSettings };
}

export default connect(mapStateToProps)(Footer);
